import { guideStatus } from "@js/api/user";

export default {
  namespaced: true,
  state: {
    showBaseGuidance: true, // 是否展示基础教学
    showBattleGuidance: true, // 是否展示对战教学
    // v2.0
    showVillageGuidance_1: true, // 是否展示第一期怪物乐园教学
    showVillageEntryGuidance_1: true, // 是否展示第一期进入怪物乐园后的教学
    showNewPet: true, // 是否有新怪兽
  },
  mutations: {
    upDateBaseGuidance(state, status) {
      state.showBaseGuidance = status;
    },
    upDateBattleGuidance(state, status) {
      state.showBattleGuidance = status;
    },
    // 乐园第一期新手引导
    upDateVillageGuidance_1(state, status) {
      state.showVillageGuidance_1 = status;
    },
    upDateVillageEntryGuidance_1(state, status) {
      state.showVillageEntryGuidance_1 = status;
    },
    upDateNewPet(state, status) {
      state.showNewPet = status;
    },
  },
  actions: {
    async upDateGuide({ commit }) {
      let data = await guideStatus();
      if (data.status == 200) {
        // data.data.arena = 1;
        commit("upDateBattleGuidance", data.data.arena == 1);
        // 乐园第一期新手引导
        commit("upDateVillageGuidance_1", data.data.play_game_v2 == 1);
        // 乐园第一期内的的新手引导
        commit(
          "upDateVillageEntryGuidance_1",
          data.data.play_game_entry_v2 == 1
        );
        // 是否需要对获取怪兽按钮高亮
        commit("upDateNewPet", data.data.new_monster_v2 == 1);
      }
    },
  },
};
